import { useEffect, useState } from 'react';

import Button from 'common-ui/button';
import Input from 'common-ui/input';
import useDebounce from 'hooks/useDebounce';
import StatusDropdown from 'pages/components/statusDropdown';

import { ActionsWrapper, FilterActions, FilterContainer } from './SearchFilter.styles';

const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'enabled', label: 'Active' },
  { value: 'disabled', label: 'Disabled' },
];

const SearchFilter = ({
  onSearchChange,
  onStatusChange,
  searchPlaceholder = 'Search...',
  showCreateButton = false,
  onCreateClick,
  createButtonText = '+ Create Source',
  hideStatusFilter = false,
  extraButton = null,
  activeStatus = 'enabled',
}) => {
  const [searchValue, setSearchValue] = useState('');
  const [selectedStatus, setSelectedStatus] = useState(activeStatus);
  const debouncedSearchValue = useDebounce(searchValue, 500);

  const handleSearchChange = (value) => {
    setSearchValue(value);
  };

  const handleStatusClick = (status) => {
    const value = status.value || status;

    setSelectedStatus(value);
    onStatusChange?.(value);
  };

  useEffect(() => {
    setSelectedStatus(activeStatus);
  }, [activeStatus]);

  useEffect(() => {
    onSearchChange?.(debouncedSearchValue);
  }, [debouncedSearchValue]);

  return (
    <FilterContainer>
      <FilterActions>
        <ActionsWrapper>
          <Input
            clearable
            value={searchValue}
            onChange={(e) => {
              handleSearchChange(e?.target?.value);
            }}
            onClear={() => {
              handleSearchChange('');
            }}
            placeholder={searchPlaceholder}
          />
          {!hideStatusFilter && (
            <StatusDropdown
              type="status"
              options={STATUS_OPTIONS}
              onStatusClick={handleStatusClick}
              activeStatus={selectedStatus}
            />
          )}
        </ActionsWrapper>
        <div style={{ display: 'flex', gap: '12px' }}>
          {extraButton}
          {showCreateButton && (
            <Button
              secondary
              onClick={onCreateClick}
              style={{ minWidth: '160px', width: 'auto' }}
            >
              {createButtonText}
            </Button>
          )}
        </div>
      </FilterActions>
    </FilterContainer>
  );
};

export default SearchFilter;
